import { ISaveApplicant } from "$hooks";
import { applicantCareersInputArguments } from "./applicantCareersInputArguments";

export const saveApplicantArguments = ({ careers, padron, ...values }: ISaveApplicant) => ({
  ...values,
  padron: padron ? padron : undefined,
  careers: applicantCareersInputArguments(careers)
});
